enum MainSliderRequiredTextType {
  Contraindications = 'contraindications',
  Bad = 'bad'
}

export default MainSliderRequiredTextType
